class RfidCell{
  constructor(value, editable = false, renderer){
    this.value = value;
    this.editable = editable;
    this.renderer = renderer;
  }

  render(){
    return this.renderer(this.value);
  }
}

export class RfidValidCell extends RfidCell{}

export class RfidInvalidCell extends RfidCell{}
